<template>
	<section class="map-section" id="map">
		<h3 class="h-text">
			<span>Проблемы,</span>
			<span class="h-text2">{{ ' которые\n' }}</span>
			<span class="h-text2">мы решаем</span>
		</h3>

		<MapSvg class="map" />

		<ul>
			<li v-for="card in cards" :key="card.icon">
				<h4>
					<div class="icon">
						<UIShIcon :name="card.icon" />
					</div>
					<span>{{ card.title }}</span>
				</h4>

				<p>{{ card.text }}</p>
			</li>
		</ul>
	</section>
</template>

<script setup lang="ts">
import MapSvg from '@/components/MapSvg.vue';

const cards = [
	{
		icon: 'file-shield-02',
		title: 'Гарантии\nот производителя',
		text: 'Работая через контракт агента, все вопросы по товару решает агент, вплоть до разбирательств в китайском суде'
	},
	{
		icon: 'credit-card-check',
		title: 'Оплата в Китай ',
		text: 'Проблемы с оплатой и переводами решит своя компания в Китае'
	},
	{
		icon: 'alert-hexagon',
		title: 'Санкционные\nриски',
		text: 'Некоторые китайские производители не рискуют поставлять товар напрямую российской стороне. Необходима китайская компания-посредник'
	}
];
</script>

<style lang="scss" scoped>
.map-section {
	margin-top: 4.444rem;
}

.h-text {
	@include useFont(dxsb);
	text-transform: uppercase;
	color: var(--color-white);
	white-space: pre-line;

	&2 {
		color: var(--color-gray300);
	}
}

.map {
	display: none;
}

ul {
	display: flex;
	flex-direction: column;
	gap: 0.667rem;
	margin-top: 1.333rem;
	color: var(--color-gray300);

	li {
		padding: 0.889rem;
		border-radius: 1.111rem;
		border: 0.056rem solid var(--color-white30);
		background-color: var(--color-gray950);

		h4 {
			display: flex;
			gap: 0.889rem;
			flex-wrap: nowrap;
			align-items: center;
			color: var(--color-white);
			@include useFont(txlb);
			text-transform: uppercase;
			white-space: pre-line;

			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				color: var(--color-brand500);
				background-color: var(--color-black50);
				@include useFixedSize(3.333rem, 3.333rem);
				border-radius: 2.667rem;

				--icon-width: 1.167rem;
				--icon-height: 1.167rem;
			}
		}

		p {
			@include useFont(tsmm);
			margin-top: 1.778rem;
			max-width: 16.889rem;
		}
	}
}

@include screen1920 {
	.map-section {
		margin-top: 7.778rem;
	}

	.h-text {
		text-align: center;
		@include useFont(dxlb);
	}

	.map {
		display: block;
		margin-top: 2.667rem;
		margin-inline: auto;
	}

	.map,
	ul {
		width: 100%;
		max-width: 92.222rem;
	}

	ul {
		display: block;
		margin-top: 0;
		position: relative;
		margin-inline: auto;

		li {
			width: 26.222rem;
			max-width: 26.222rem;
			padding: 1.778rem;
			border-radius: 1.333rem;
			position: absolute;

			&:nth-of-type(1) {
				left: 2.111rem;
				bottom: 8.333rem;
			}

			&:nth-of-type(2) {
				right: 2.111rem;
				bottom: 20.444rem;
			}

			&:nth-of-type(3) {
				right: 10.722rem;
				bottom: 0;
			}

			h4 {
				gap: 1.333rem;
				@include useFont(dxsb);

				.icon {
					@include useFixedSize(4.444rem, 4.444rem);
					border-radius: 3.556rem;

					--icon-width: 1.556rem;
					--icon-height: 1.556rem;
				}
			}

			p {
				@include useFont(txlm);
				margin-top: 1.778rem;
				max-width: unset;
			}
		}
	}
}
</style>
